import { useMutation } from "@tanstack/react-query";

import { UserOnboardingMutation, UserOnboardingResponse } from "./types";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast } from "@/utils/toast";

//NOTE: onboarding steps (previously it was questions)
export const USER_ONBOARDING_REQUEST_PARAM_QUESTION_KEYS = {
  ABOUT_USER: "about_user",
  USE_CASE: "use_case",
} as const;

export const useUserOnboarding = (userToken: string, options?: { onSuccess?: () => void }) =>
  useMutation<UserOnboardingResponse, string, UserOnboardingMutation>(
    ({ onboarding_question_key, response }: UserOnboardingMutation) =>
      fetch(ENDPOINTS.user_onboarding, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          onboarding_question_key,
          response,
        }),
      }).then(handleResponse),
    {
      onError: () => {
        displayErrorToast("Something went wrong");
      },
      ...options,
    },
  );
